// Generated by CoffeeScript 2.7.0
export var LogicalFieldMixin = {
  props: {
    disappearedFieldIds: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      previousFieldVm: null,
      currentHittedFieldIds: []
    };
  },
  computed: {
    logical: function() {
      return !_.isEmpty(this.field.logic_rule);
    },
    hittedFieldIds: function() {
      var ref;
      return _.without(_.union((ref = this.previousFieldVm) != null ? ref.hittedFieldIds : void 0, this.currentHittedFieldIds), this.field.id);
    },
    visible: function() {
      var ref;
      return (!_.contains(this.disappearedFieldIds, this.field.id) || _.contains((ref = this.previousFieldVm) != null ? ref.hittedFieldIds : void 0, this.field.id)) && !(this.field.visibility === 'private_visibility' && !this.isAdmin);
    }
  },
  watch: {
    visible: function(newVal) {
      if (newVal) {
        return typeof this.handleLogic === "function" ? this.handleLogic() : void 0;
      } else {
        return this.currentHittedFieldIds = [];
      }
    }
  },
  methods: {
    setPreviousFieldVm: function(vm) {
      return this.previousFieldVm = vm;
    },
    debouncedHandleLogic: _.noop,
    debouncedHandleLogicAndEmitEvent: function() {
      this.debouncedHandleLogic();
      return this.$nextTick(function() {
        return this.$emit('logicHandled');
      });
    },
    handleLogic: function(immediate = false) {
      if (immediate) {
        return _.defer(this.debouncedHandleLogic);
      } else {
        if (this.debouncedHandleLogicFunc == null) {
          this.debouncedHandleLogicFunc = _.debounce(this.debouncedHandleLogicAndEmitEvent, 500);
        }
        return this.debouncedHandleLogicFunc();
      }
    }
  }
};

//detail
export var LogicDetailGroupMixin = {
  computed: {
    visible: function() {
      var ref;
      return (ref = this.groupedFieldList) != null ? ref.visible : void 0;
    }
  }
};

export var LogicDetailFieldMixin = {
  computed: {
    visible: function() {
      var ref;
      if (!this.groupViewChilden.some(function(child) {
        return child.visible;
      })) {
        return false;
      }
      return !_.contains(this.disappearedFieldIds, this.field.id) || _.contains((ref = this.previousFieldVm) != null ? ref.hittedFieldIds : void 0, this.field.id);
    }
  }
};

//field-list
export var LogicFieldListMixin = {
  computed: {
    visible: function() {
      return this.fieldChildren.some(function(child) {
        return child.visible;
      });
    }
  },
  methods: {
    logicHandledFunc: function() {
      return this.$emit('logicHandled');
    }
  }
};
